// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'


import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    InputAdornment,
    Fab,
    OutlinedInput,
    Autocomplete
} from '@mui/material'

import InputLabel from '@mui/material/InputLabel'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import React from 'react';
import { useToast } from '../../../../components/ToastProvider';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valModel, setValModel] = useState<any>(null)
    const [listModel, setListModel] = useState<any[]>([])

    const [valJenis, setValJenis] = useState<any>(null)
    const [listJenisModel, setListJenisModel] = useState<any[]>([])

    const [file, setFile] = useState<any>(null)
    const [txtFile, setTxtFile] = useState<any>(null)

    useEffect(() => {
        getDoctag()
        getListJenis()
    }, [])

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {sysmenu_id: 47},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDoctag(data)
                    if(data.length === 1) {
                        setValDoctag(data[0])
                        setValue('sysdoctag_id', data[0]?.id)
                    }
                } else {
                    showToast(response.data.message, 'error');
                }
            })

    }

    const getModel = (jenisModel:any) => {
        const url = apiUrl.apiUrl + '/sales/model/list-combo?jenis_model=' + jenisModel
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListModel(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getListJenis = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-jenis-model'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListJenisModel(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        sdmodel_id: any,
        kode: any,
        jenis_model: any,
        nama_model: any,
        keterangan: any,
        panjang: any,
        lebar: any,
        tinggi: any,
        image: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        jenis_model: '',
        sysdoctag_id: '',
        sdmodel_id: '',
        kode: '',
    }

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompleteModel = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sdmodel_id', newValue?.id)
        setValModel(newValue)
        if(newValue?.id != null && newValue?.id != undefined) {
            const url = apiUrl.apiUrl + `/sales/model/detail/${newValue.id}`;
            axios
            .get(url, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const detail = response.data.data;
                    setValue('panjang', detail.panjang);
                    setValue('lebar', detail.lebar);
                    setValue('tinggi', detail.tinggi);
                    setValue('nama_model', detail.nama_model);
                    setValue('kode', detail.kode);
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            });
        }
    }

    const handleChangeAutocompleteJenis = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jenis_model', newValue?.nama)
        setValJenis(newValue)        
        if(newValue?.nama != null && newValue?.nama != undefined) {
            getModel(newValue?.nama);
        }
    }
    // UPLOAD ATTACHMENT
    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        // const image = await resizeFile(files)
        setFile(files)
        setTxtFile(nameFiles)
        setValue('image', files)
    }

    const onSubmit = (data: any) => {
        const url = apiUrl.apiUrl + '/sales/model/add'
        const formData = new FormData();
        formData.append("syscabang_id", data.syscabang_id);
        formData.append("sysdoctag_id", data.sysdoctag_id);
        formData.append("sdmodel_id", data.sdmodel_id);
        formData.append("kode", data.kode);
        formData.append("jenis_model", data.jenis_model);
        formData.append("nama_model", data.nama_model);
        formData.append("keterangan", data.keterangan);
        formData.append("panjang", data.panjang);
        formData.append("lebar", data.lebar);
        formData.append("tinggi", data.tinggi);
        formData.append("image", file);

        axios.post(url, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
        }
    })
        .then(response => {
            if (response.data.success) {
                showToast(response.data.message, 'success');
                const id = response.data.data
                navigate('/sales/model/detail/' + id)
            } else {
                showToast(response.data.message, 'error');
            }
        })
        .catch(error => {
            showToast(error.message, 'error');
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Model
                    </Typography>
                    <Divider sx={{ m: 0 }} />

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Document Tag
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1, mt: 1 }}>
                                    Jenis Model
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis_model'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valJenis}
                                                options={listJenisModel}
                                                id='jenis_model'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteJenis}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Jenis Model'
                                                        error={Boolean(errors.jenis_model)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis_model && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    &nbsp;
                                </Typography>
                                <Fab color='primary' size='medium' onClick={() => {
                                    Swal.fire({
                                        title: 'Tambah Jenis Model',
                                        input: 'text',
                                        inputLabel: 'Nama Jenis Model',
                                        inputPlaceholder: 'Masukkan nama jenis model',
                                        showCancelButton: true,
                                        confirmButtonText: 'Simpan',
                                        cancelButtonText: 'Batal',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Form ini tidak boleh kosong.'
                                            }
                                        }
                                    }).then(result => {
                                        if (result.isConfirmed && result.value) {
                                            const jenisModel = result.value;
                                            const data = { jenis_model: jenisModel };
                                            const url = apiUrl.apiUrl + '/sales/model/add-jenis-model';
                                            axios
                                                .post(url, data, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    if (response.data.success) {
                                                        Swal.fire({
                                                            title: 'Berhasil',
                                                            text: response.data.message,
                                                            icon: 'success',
                                                            timer: 1000,
                                                            timerProgressBar: true
                                                        });
                                                        getListJenis();
                                                    } else {
                                                        Swal.fire({
                                                            title: 'Gagal',
                                                            text: response.data.message,
                                                            icon: 'error'
                                                        });
                                                    }
                                                })
                                                .catch(error => {
                                                    Swal.fire({
                                                        title: 'Error',
                                                        text: error.message,
                                                        icon: 'error'
                                                    });
                                                });
                                        }
                                    });
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Parent Model
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sdmodel_id'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valModel}
                                                options={listModel}
                                                id='sdmodel_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteModel}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Parent Model'
                                                        error={Boolean(errors.sdmodel_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sdmodel_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Model
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_model'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Model'
                                                error={Boolean(errors.nama_model)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama_model && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Kode Model
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kode Model'
                                                error={Boolean(errors.kode)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Panjang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='panjang'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Panjang'
                                                type='number'
                                                error={Boolean(errors.panjang)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.panjang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Lebar
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='lebar'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Lebar'
                                                type='number'
                                                error={Boolean(errors.lebar)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.lebar && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Tinggi
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tinggi'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tinggi'
                                                type='number'
                                                error={Boolean(errors.tinggi)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tinggi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Upload Gambar
                                </Typography>
                                <input
                                    type='file'
                                    ref={hiddenFileInput}
                                    onChange={handleFile}
                                    style={{ display: 'none' }}
                                    accept='image/png, image/jpg, image/jpeg'
                                ></input>
                                <FormControl fullWidth>
                                    <Controller
                                        name='image'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <>
                                                <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                                <OutlinedInput
                                                    label='Foto'
                                                    value={txtFile}
                                                    id='input-file'
                                                    type={'text'}
                                                    error={Boolean(errors.image)}
                                                    startAdornment={
                                                        <Box
                                                            onClick={handleClick}
                                                            onMouseDown={e => e.preventDefault()}
                                                            sx={{ cursor: 'pointer' }}
                                                        >
                                                            <InputAdornment position='start'>
                                                                Pilih Gambar &nbsp;
                                                                <IconButton edge='start' aria-label='paperclip'>
                                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </Box>
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                    {errors.image && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                rows={2}
                                                multiline
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
